export enum MetadataKey {
  Resource = 'api-platform:resource',
  Properties = 'api-platform:properties',
  SubResources = 'api-platform:sub-resources',
  SubCollections = 'api-platform:sub-collections',
  Identifier = 'api-platform:identifier',
  Outputs = 'api-platform:outputs',
  Inputs = 'api-platform:inputs',
}
